import React, { Fragment, Component } from 'react';
import { Item, Label, Modal, Divider } from 'semantic-ui-react';
import DocumentPreview from '../DocumentPreview';
import List from './List';

class AttachmentsList extends Component {
  state = { open: false, showAttachments: false };

  countButtons = () => {
    const { buttons, attachments } = this.props;
    if (!buttons) return attachments.length;
    let count = 0;

    Object.values(buttons).forEach(val => {
      if (val === true) count++;
    });
    return attachments.length - count;
  };

  toggleAttachments = () =>
    this.setState({ showAttachments: !this.state.showAttachments });

  handleOpenAttachmentPrev = attachment =>
    this.setState({ open: true, shownAttachment: attachment });

  handleCloseAttachmentPrev = () => this.setState({ open: false });

  render = () => {
    const { open, shownAttachment, showAttachments } = this.state;
    const {
      attachments,
      toggleImportLabel,
      onImportToggleClick,
      onImportAllToggleClick
    } = this.props;
    const shownAttachmentType =
      shownAttachment && shownAttachment.documentContentType;

    if (attachments.length === 0) return <h2> No attachments </h2>;

    return (
      <Fragment>
        <Modal
          open={open}
          dimmer={true}
          basic
          closeIcon
          onClose={this.handleCloseAttachmentPrev}
        >
          <Modal.Content
            onClick={
              shownAttachmentType === 'application/pdf'
                ? null
                : this.handleCloseAttachmentPrev
            }
          >
            <DocumentPreview document={shownAttachment} />
          </Modal.Content>
        </Modal>
        <Divider fitted />
        <Item.Group className="inline-items">
          <List
            onOpenAttachmentPrev={this.handleOpenAttachmentPrev}
            toggleAttachments={this.toggleAttachments}
            showAttachments={showAttachments}
            {...this.props}
          />
        </Item.Group>
        <Divider />
        {!toggleImportLabel &&
          !!attachments &&
          attachments.length > 0 &&
          onImportToggleClick &&
          this.countButtons() +
            ' out of ' +
            attachments.length +
            ' attachments marked for import '}
        {!toggleImportLabel &&
          !!attachments &&
          attachments.length > 3 &&
          onImportAllToggleClick && (
            <div style={{ display: 'inline' }}>
              <Label
                size="mini"
                name={'btnImport'}
                color={'green'}
                onClick={onImportAllToggleClick.bind(this, true)}
                style={{ cursor: 'pointer' }}
              >
                Import All
              </Label>
              <Label
                size="mini"
                name={'btnImport'}
                color={'red'}
                onClick={onImportAllToggleClick.bind(this, false)}
                style={{ cursor: 'pointer' }}
              >
                Discard All
              </Label>
            </div>
          )}
      </Fragment>
    );
  };
}

export default AttachmentsList;



// WEBPACK FOOTER //
// ./src/component/AttachmentsList/index.js